import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import team from "../Images/team.gif";
import leadm from "../Images/leadm.svg";
import inventm from "../Images/inventm.png";
import more from "../Images/more.gif";
import processm from "../Images/processm.png";
import billingm from "../Images/billingm.png";
import { Link } from "react-router-dom";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";

export default function About() {
  return (
    <>
      <SEO
        title="About Us - Next-Gen AI ERP & CRM Software"
        description="Learn about EnteliPro, a cutting-edge AI ERP and CRM platform empowering modern businesses with automated workflows, predictive insights, and digital operations."
        keywords="About EnteliPro, AI ERP Software, CRM Solutions for Businesses, Cloud ERP Platform, Intelligent Business Management"
        canonical="https://www.entelipro.com/about"
        ogImage="https://www.entelipro.com/static/media/team.gif"
      />

      <Navbar />
      {/* breadcrumbs  */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">About</li>
            </ul>
          </div>
        </div>
      </section>
      {/* breadcrumbs  */}
      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img src={team} alt="EnteliPro Dedicated Business Solutions Team" className="img-responsive " />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.2rem", fontWeight: "700", marginBottom: "1rem" }}>
                  About {`${project_name}`}
                </h1>
                <p className="para">
                  {" "}
                  Business solutions platform for the digital age.{" "}
                  {`${project_name}`} has a very well-equipped solution with
                  some unique features. Providing business solutions across all
                  industry segments to give access to all. Every business has
                  the right to access world-className business solutions. It's
                  the guiding principle behind our work and reinforces our
                  belief that the best technology makes your business
                  smarter.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="w3l-recent-work-hobbies">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>A product to meet every need</h3>
              <p className="para"> </p>
            </div>
            <div className="row about-about">
              <div className="col-lg-4 col-md-6">
                <div className="about-grids">
                  <h4>Who we are</h4>
                  <p className="para">
                    Young Entrepreneurs foster the next generation of
                    entrepreneurs and business leaders and have the right
                    mindset to provide a good platform for every business.
                  </p>
                  <div className="mt-3 about-list">
                    <ul>
                      <li>
                        <span
                          className="fa fa-chevron-circle-right"
                          aria-hidden="true"
                        ></span>
                        <p className="para"> To create integrated values</p>
                      </li>
                      <li>
                        <span
                          className="fa fa-chevron-circle-right"
                          aria-hidden="true"
                        ></span>
                        <p className="para">
                          Take on a stronger responsibility
                        </p>
                      </li>
                      <li>
                        <span
                          className="fa fa-chevron-circle-right"
                          aria-hidden="true"
                        ></span>
                        <p className="para">Deliver innovative products </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Discovery</h4>
                  <p className="para">
                    To constantly reinvents new business solutions across all
                    domains with new technology and deliver to pursue happier
                    and richer lives. We develop and expand strategic products
                    for providing the business experience.
                  </p>
                  <div className="mt-3 about-list">
                    <ul>
                      <li>
                        <span
                          className="fa fa-chevron-circle-right"
                          aria-hidden="true"
                        ></span>
                        <p className="para">Deliver innovative design </p>
                      </li>

                      <li>
                        <span
                          className="fa fa-chevron-circle-right"
                          aria-hidden="true"
                        ></span>
                        <p className="para">
                          To cater diverse business preferences
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 about-line-top">
                <div className="about-grids">
                  <h4>Our Vision</h4>
                  <p className="para">
                    To be recognized as the industry leader driving
                    modernization in IT services in the developing world and to
                    be the center of modern Research and Development in the IT
                    sector.
                  </p>
                  <div className="mt-3 about-list">
                    <ul>
                      <li>
                        <span
                          className="fa fa-chevron-circle-right"
                          aria-hidden="true"
                        ></span>
                        <p className="para"> Improve ERP services</p>
                      </li>
                      <li>
                        <span
                          className="fa fa-chevron-circle-right"
                          aria-hidden="true"
                        ></span>
                        <p className="para">Modern Research and Development </p>
                      </li>
                      <li>
                        <span
                          className="fa fa-chevron-circle-right"
                          aria-hidden="true"
                        ></span>
                        <p className="para">
                          Develop and deliver best services.
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="w3l-about ">
        <div className="skills-bars text-center">
          <div className="container">
            <div className="row counter-width">
              <div className="counter-counter col-lg-3 col-md-3 col-sm-6">
                <h4>Active clients</h4>
                <span>250</span>
              </div>
              <div className="counter-counter col-lg-3 col-md-3 col-sm-6">
                <h4>Projects Done</h4>
                <span>170+</span>
              </div>
              <div className="counter-counter col-lg-3 col-md-3 col-sm-6">
                <h4>Success Rate</h4>
                <span>90%</span>
              </div>
              <div className="counter-counter col-lg-3 col-md-3 col-sm-6">
                <h4>Get Awards</h4>
                <span>70+</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="w3l-team-main-6">
        {/* team-grids */}
        <div className="team-content">
          <div className="container">
            <div className="main-titles-head text-center">
              <h3 className="header-name">Our Awesome Features</h3>
            </div>
            <div className="row grid-col-4 text-center">
              <div className="team-colomn col-lg-3 col-md-6 col-sm-6">
                <div className="team-main-6">
                  <div className="right-team-9">
                    <Link to="/leadmanagement">
                      <img className="img-responsive" src={leadm} alt="EnteliPro AI Lead Management Module" />
                    </Link>
                    <br />
                    <h6>
                      <Link to="/leadmanagement" className="title-team-32">
                        Lead Management
                      </Link>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="team-colomn col-lg-3 col-md-6 col-sm-6">
                <div className="team-main-6">
                  <div className="right-team-9">
                    <Link to="/inventorymanagement">
                      <img className="img-responsive" src={inventm} alt="EnteliPro Cloud Inventory Management System" />
                    </Link>
                    <br />
                    <h6>
                      <Link to="/inventorymanagement" className="title-team-32">
                        Inventory Management
                      </Link>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="team-colomn col-lg-3 col-md-6 col-sm-6">
                <div className="team-main-6">
                  <div className="right-team-9">
                    <Link to="/processmanagement">
                      <img className="img-responsive" src={processm} alt="EnteliPro Automated Business Process Management" />
                    </Link>
                    <br />
                    <h6>
                      <Link to="/processmanagement" className="title-team-32">
                        Process Management System
                      </Link>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="team-colomn col-lg-3 col-md-6 col-sm-6">
                <div className="team-main-6">
                  <div className="right-team-9">
                    <Link to="/invoicemanagement ">
                      <img className="img-responsive" src={billingm} alt="EnteliPro Invoice and Billing Management" />
                    </Link>
                    <br />
                    <h6>
                      <Link to="/invoicemanagement" className="title-team-32">
                        Invoice Management System
                      </Link>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="row grid-col-4 text-center">
              <div className="team-colomn col-lg-4 col-md-6 scol-sm-6"></div>
              <div className="team-colomn col-lg-4 col-md-6 scol-sm-6">
                <div className="team-main-6">
                  <div className="right-team-9">
                    <Link to="/features">
                      <img className="img-responsive" src={more} alt="Explore More EnteliPro Enterprise CRM Features" />
                    </Link>
                    <h6>
                      <Link to="/features" className="title-team-32">
                        Explore More Features
                      </Link>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
